import React from 'react';
import {isAndroid} from 'utilities/userAgent';
import {FluidRatio} from './Ratio';

const RATIOS = {
  PORTRAIT: {x: 3, y: 4},
  LANDSCAPE: {x: 6, y: 2},
};

// Determine if device is in portrait mode. On android, an open keyboard can
// match as landscape, so we check availHeight/Width. On iOS, availHeight/Width
// don't respect orientation, so we have to use isAndroid.
const checkIsPortait = orientation => () => ({
  isPortrait:
    orientation.matches ||
    (isAndroid && screen.availHeight > screen.availWidth),
});

class OrientationScale extends React.Component {
  state = {
    isPortrait: true,
  };

  componentDidMount() {
    this.orientation = window.matchMedia('(orientation: portrait)');
    this.orientation.addListener(this.handleOrientationChange);
    this.setState(checkIsPortait(this.orientation));
  }

  componentWillUnmount() {
    this.orientation.removeListener(this.handleOrientationChange);
  }

  handleOrientationChange = orientation => {
    this.setState(checkIsPortait(orientation));
  };

  render() {
    const {children} = this.props;
    const ratio = this.state.isPortrait ? RATIOS.PORTRAIT : RATIOS.LANDSCAPE;

    return (
      <FluidRatio x={ratio.x} y={ratio.y}>
        {children}
      </FluidRatio>
    );
  }
}
export default OrientationScale;
